import { AutogenLayoutMcUnitAllQuickInfo } from "./autogen/AutogenLayoutMcUnitAllQuickInfo";
import { DataSourceExecutionEvent } from "@mcleod/components";

export class McUnitAllQuickInfo extends AutogenLayoutMcUnitAllQuickInfo {

    /** This is an event handler for the afterExecution event of sourceMcUnitAll. */
    sourceMcUnitAllAfterExecution(event: DataSourceExecutionEvent) {
        if (!(event.data?.data)) {
            this.labelError.visible = true;
            this.panelUnit.visible = false;
        }
    }
}
